import React from "react";
import { useLocation } from "react-router-dom";
const Blogpage = () => {
  const Location = useLocation();
  return (
    <div className="container-fluid blogpage">
      <h1>{Location.state.title}</h1>
      {/* Download as pdf button */}
      <a
        href="https://www.google.com/"
        target="_blank"
        className=""
        role="button"
        aria-pressed="true"
      >
        {/* <button type="button" className="btn bot-btn">
          Download pdf
        </button> */}
      </a>
      <br />
      {/* <h5>Published:today</h5> */}
      <hr className="edithrblogpage" />
      {/* <img
        src={require(`./images/${Location.state.img}`)}
        className="img-fluid"
        alt="Blog-image"
      /> */}
      <br /> <br />
      <p>{Location.state.desc}</p>
    </div>
  );
};

export default Blogpage;

// Pass data
<Blogpage
  title="Beautiful Blog Design - Title"
  imageUrl="https://images.pexels.com/photos/416778/pexels-photo-416778.jpeg"
  publishedDate="April 07, 2023"
  text="Lorem ipsum dolor sit amet consectetur adipisicing elit. At, beatae commodi asperiores molestias cupiditate eligendi sed, sint porro dolor fuga harum tempore dignissimos nobis natus numquam laborum accusamus minima iure..."
/>;
